import { Button as CButton, Text, useDisclosure, VStack } from '@chakra-ui/react';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '../components/atoms/Button';
import { CellphoneInput, CPFInput, Input } from '../components/atoms/Input';
import { useProfile } from '../contexts/ProfileProvider';
import { useTheme } from '../contexts/ThemeProvider';
import { DeleteAccountModal } from './DeleteAccountModal';

export function ProfileForm() {
  const { name, metadata } = useTheme();
  const { profile, updateProfile, isLoading } = useProfile();
  const { register, setValue, handleSubmit } = useForm();
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (!profile) return;

    setValue('full_name', profile.fullName);
    setValue('telephone', profile?.telephone ?? '');
  }, [profile, setValue]);

  function doUpdateProfile(data: Record<string, string | boolean>) {
    updateProfile(data);
  }

  return (
    <>
      <VStack spacing={8} w={'100%'}>
        <Text fontSize={'14px'}>
          Verifique aqui todos seus dados pessoais vinculados à {name}. Alguns campos não podem ser editados.
        </Text>
        <form onSubmit={handleSubmit(doUpdateProfile)} style={{ width: '100%' }}>
          <VStack spacing={5} w={'100%'}>
            <Input
              {...register('full_name')}
              disabled={typeof metadata?.profileedit !== 'undefined' ? !metadata.profileedit : false}
              label="Nome Completo"
            />
            <Input disabled value={profile?.email} label="Email" />
            <CPFInput disabled value={profile?.cpf} label="CPF" />
            <CellphoneInput {...register('telephone')} label="Celular" />
            <Button isLoading={isLoading} type="submit" marginTop={'10px'}>
              Atualizar
            </Button>
            <CButton variant="ghost" onClick={onOpen}>
              Quero apagar minha conta
            </CButton>
          </VStack>
        </form>
      </VStack>
      <DeleteAccountModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}
